import "./style.css";
import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { CiSearch } from "react-icons/ci";
import { Form, InputGroup, Row, Col, Button } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import Avatar from "../../../assets/Images/user-avatar.jpg";
import DataTable from "react-data-table-component";
import { PiPencilSimpleLineBold } from "react-icons/pi";
import { RiDeleteBinLine } from "react-icons/ri";
import { AgGridReact } from "ag-grid-react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useDispatch, useSelector } from "react-redux";
import {
  commonSaveData,
  commonGetData,
  initCommonState,
} from "../../../redux/slices/commonSlice";
import { fetchData, initRoleState } from "../../../redux/slices/roleSlice";
import {
  getEmployeeManageListPath,
  updateEmployerManageListPath,
} from "../../../services/config";
import Widgets from "../../../components/Widgets";
import WidgetsIcon from "../../../components/Widgets/icon";
import CustomPagination from "../../../components/CustomPagination";
import { HasPermission } from "../../../services/hasPermission";
import { values } from "lodash";

const EmployeeManager = () => {
  const dispatch = useDispatch();
  const state = useSelector((state) => state.common);
  const roleState = useSelector((state) => state.roles);

  const user = JSON.parse(localStorage.getItem("user_data"));

  const [employeeManagerList, setEmployeeManagerList] = useState([]);
  const [roles, setRoles] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState(employeeManagerList);

  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const getEmployeeManagerList = useCallback(() => {
    dispatch(commonGetData(`${getEmployeeManageListPath}${user.user_id}`));
    dispatch(fetchData());
  }, []);

  useEffect(() => {
    getEmployeeManagerList();
  }, []);

  useEffect(() => {
    if (state.commonGetSuccess) {
      setEmployeeManagerList(state.commonGetData);
      setFilteredData(state.commonGetData);
    }
    if (roleState.roleGetSuccess) {
      setRoles(roleState.roleGetData);
      dispatch(initRoleState());
    }
  }, [state.commonGetSuccess, roleState.roleGetSuccess]);

  const handleInputSearch = (event) => {
    const value = event.target.value || "";
    setSearchText(value);
  };

  const handleSearch = () => {
    const value = searchText;

    if (value && typeof value === "string") {
      const lowerCaseValue = value.toLowerCase();

      const filtered = employeeManagerList.filter((item) =>
        item.full_name.toLowerCase().includes(lowerCaseValue)
      );
      setFilteredData(filtered);
    }
    if (value == "") {
      setFilteredData(employeeManagerList);
    }
  };

  const columns = [
    {
      headerName: "Employee ID",
      width: "120px",
      cellRenderer: (row) => {
        return row.data.mobile ? row.data.mobile : "-";
      },
    },
    {
      headerName: "Full Name",
      width: "200px",
      cellRenderer: (row) => {
        return (
          <div style={{ display: "flex", alignItem: "center", gap: "10px" }}>
            <div
              style={{
                position: "relative",
                top: "2px",
                width: "30px",
                height: "30px",
                borderRadius: "50%",
              }}
            >
              <img
                src={Avatar}
                alt="avatar"
                style={{ width: "30px", height: "30px", borderRadius: "50%" }}
              />
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: "10px",
                position: "relative",
                top: "2px",
              }}
            >
              <h4>{row.data.full_name}</h4>
              {/* <span>({row.data.empRoleName})</span> */}
            </div>
          </div>
        );
      },
    },
    {
      headerName: "Email Address",
      width: "250px",
      cellRenderer: (row) => {
        return row.data.email ? row.data.email : "-";
      },
    },

    {
      headerName: "Mobile Number",
      cellRenderer: (row) => {
        return row.data.mobile ? row.data.mobile : "-";
      },
    },

    {
      headerName: "Role",
      field: "empRoleName",
    },

    {
      headerName: "Status",
      width: "100px",
      cellRenderer: (row) => {
        return (
          <div
            className={row.data.status == "1" ? "greenStatus" : "orangeStatus"}
          >
            {" "}
            {row.data.status == "1" ? "Active" : "InActive"}{" "}
          </div>
        );
      },
    },

    {
      headerName: "Action",
      width: "400px",
      cellRenderer: (row) => {
        return (
          <div>
            {HasPermission("Employees & Managers", "edit") && (
              <PiPencilSimpleLineBold
                style={{ cursor: "pointer", fontSize: 30, color: "blue" }}
                onClick={(e) => {
                  handleSubmit(e, row);
                }}
              />
            )}

            {HasPermission("Employees & Managers", "delete") && (
              <RiDeleteBinLine className="delete-icon"
                style={{ cursor: "pointer", fontSize: 30, color: "red" }}
              />
            )}

            {/* <Form.Select
              style={{
                width: "100%",
                height: "35px",
                position: "relative",
                top: "2px",
                lineHeight: "17px",
              }}
              onChange={(e) => {
                HasPermission("Employees & Managers", "edit") &&
                  handleSubmit(e, row);
              }}
              value={row.emp_role}
              className="universal-input-one"
            >
              {roles.map((r, i) => {
                return HasPermission("Employees & Managers", "edit") ? (
                  <option
                    value={r.roleId}
                    selected={
                      parseInt(row.data.emp_role) == parseInt(r.roleId)
                        ? "selected"
                        : ""
                    }
                    key={i}
                  >
                    {r.rolename}
                  </option>
                ) : (
                  parseInt(row.data.emp_role) == parseInt(r.roleId) && (
                    <option
                      value={r.roleId}
                      selected={
                        parseInt(row.data.emp_role) == parseInt(r.roleId)
                          ? "selected"
                          : ""
                      }
                      key={i}
                    >
                      {r.rolename}
                    </option>
                  )
                );
              })}
            </Form.Select> */}
          </div>
        );
      },
    },
  ];

  const [employmentType, setEmploymentType] = useState("");

  const [empRoleId, setEmpRoleId] = useState({
    staffId: null,
    emp_role: null,
    isOpenPopup: false,
  });

  const handleSubmit = (e, row) => {
    const {
      target: { value },
    } = e;
    setEmploymentType(value);
    setEmpRoleId((pre) => ({
      ...pre,
      staffId: row.data.staffId,
      emp_role: row.data.emp_role,
      isOpenPopup: true,
    }));
  };

  const handleClose = () => {
    setEmpRoleId((pre) => ({
      ...pre,
      isOpenPopup: false,
    }));
  };

  const handleEditedValue = (value) => {
    setEmpRoleId((pre) => ({
      ...pre,
      emp_role: value,
    }));
  };

  const submitEditedValue = () => {
    let d = {
      path: updateEmployerManageListPath,
      data: {
        userId: user.user_id,
        staffId: parseInt(empRoleId.staffId),
        emp_role: parseInt(empRoleId.emp_role),
      },
    };
    dispatch(commonSaveData(d));
  };

  useEffect(() => {
    if (state.commonSuccess) {
      toast.success(state.commonMessage);
      dispatch(initCommonState());
      getEmployeeManagerList();
      setSearchText("");
      setEmpRoleId((pre) => ({
        ...pre,
        isOpenPopup: false,
      }));
    }
    if (state.commonError) {
      toast.error(state.commonMessage);
      dispatch(initCommonState());
      setSearchText("");
      setEmpRoleId((pre) => ({
        ...pre,
        isOpenPopup: false,
      }));
    }
  }, [state.commonSuccess, state.commonError]);

  const paginationPageSize = 10;
  const paginationPageSizeSelector = [10, 20, 50, 100];

  return (
    <div
      className="SettingBody"
      style={{
        position: "fixed",
        width: "calc(100%)",
        height: "100%",
        borderRadius: "7px",
        overflow: "auto",
        backgroundColor: "transparent",
      }}
    >
      <ToastContainer
        position="top-right"
        autoClose={2000}
        className="toast-custom"
      />

      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={empRoleId.isOpenPopup}
        onClose={handleClose}
      >
        <DialogTitle className="dialog-title">
          <div className="dialog-title-icon">
            <span className="close-icon" onClick={handleClose}>
              X
            </span>
            <span className="title">Update</span>
          </div>
          <button className="universal-btn" onClick={submitEditedValue}>
            Edit
          </button>
        </DialogTitle>

        <DialogContent style={{ paddingBottom: "40px" }}>
          <Form.Select
            style={{
              width: "100%",
              height: "35px",
              position: "relative",
              top: "20px",
              lineHeight: "17px",
            }}
            onChange={(e) => {
              HasPermission("Employees & Managers", "edit") &&
                handleEditedValue(e.target.value);
            }}
            value={empRoleId.emp_role}
            className="universal-input-one"
          >
            {roles.map((r, i) => {
              return HasPermission("Employees & Managers", "edit") ? (
                <option
                  value={r.roleId}
                  selected={
                    parseInt(empRoleId.emp_role) == parseInt(r.roleId)
                      ? "selected"
                      : ""
                  }
                  key={i}
                >
                  {r.rolename}
                </option>
              ) : (
                parseInt(empRoleId.emp_role) == parseInt(r.roleId) && (
                  <option
                    value={r.roleId}
                    selected={
                      parseInt(empRoleId.emp_role) == parseInt(r.roleId)
                        ? "selected"
                        : ""
                    }
                    key={i}
                  >
                    {r.rolename}
                  </option>
                )
              );
            })}
          </Form.Select>
        </DialogContent>
      </Dialog>

      <div className="Branches-container">
        <Widgets
          icon={
            <WidgetsIcon
              icon={
                <Link to="/setting/" className="color-white">
                  <ArrowBackIcon />
                </Link>
              }
              title="Company  Employee & Managers"
            />
          }
          // button={
          //   <Row className="mb-1 mt-1 p-3">
          //     <Col sm="12">
          //       <InputGroup size="sm">
          //         <InputGroup.Text
          //           style={{
          //             backgroundColor: "transparent",
          //             border: "1px solid gray",
          //             borderRight: "none",
          //           }}
          //         >
          //           <CiSearch className="color-white" />
          //         </InputGroup.Text>
          //         <Form.Control
          //           value={searchText}
          //           onChange={handleInputSearch}
          //           placeholder="Search"
          //           style={{
          //             backgroundColor: "transparent",
          //             border: "1px solid gray",
          //             borderRight: "none",
          //             fontSize: "16px",
          //           }}
          //           className="search-box"
          //         />
          //         <InputGroup.Text
          //           style={{
          //             backgroundColor: "transparent",
          //             border: "1px solid gray",
          //             borderLeft: "none",
          //           }}
          //         >
          //           <Button
          //             style={{ height: "30px", lineHeight: "10px" }}
          //             variant="primary"
          //             onClick={handleSearch}
          //             className="universal-btn"
          //           >
          //             Search
          //           </Button>
          //         </InputGroup.Text>
          //       </InputGroup>
          //     </Col>
          //   </Row>
          // }
          body={
            <>
              <div
                className="ag-theme-quartz custom-grid"
                style={{
                  height: "calc(100vh - 240px)",
                  width: "100%",
                  padding: "20px",
                }}
              >
                <AgGridReact
                  columnDefs={columns}
                  rowData={Array.isArray(filteredData) ? filteredData : []}
                  omLayout="autoHeight"
                  pagination={true}
                  paginationPageSize={paginationPageSize}
                  onGridReady={onGridReady}
                />
              </div>

              <div className="d-flex align-items-center justify-content-between custom-pagination">
                {gridApi && <CustomPagination gridApi={gridApi} />}
              </div>
            </>
          }
        />
      </div>
    </div>
  );
};

export default EmployeeManager;
